import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import TopicCard from '@/components/feature/TopicCard';
import { topicList } from '@/mocks/topics';
import { formatHeat, statusStyle } from '@/utils/format';

const [featured, ...restTopics] = topicList;
const gridTopics = restTopics.slice(0, 3);

function TopicShowcase() {
  return (
    <section className="w-full border-y border-background-200/80 bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <SectionHeading
          eyebrow="专题跟踪"
          title="正在发酵的热点专题"
          desc="每个专题把事件起因、扩散路径、各方回应与媒体报道差异串成一条完整时间线，不用再自己拼线索。"
        />
        <Link
          to="/topics"
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          进入专题库
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[1.15fr_1fr]">
        <article className="group relative flex min-h-[320px] flex-col justify-end overflow-hidden rounded-lg">
          <img
            src={featured.cover}
            alt={`${featured.title} - 网报吃瓜热门专题`}
            title={`${featured.title} - 网报吃瓜专题跟踪`}
            className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/50 to-foreground-950/10" />
          <div className="relative p-5 md:p-7">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-md bg-background-50/95 px-2.5 py-1 text-xs font-medium text-foreground-900">
                {featured.category}
              </span>
              <span
                className={`rounded-md px-2.5 py-1 text-xs font-medium ${
                  statusStyle[featured.status] || 'bg-accent-500 text-background-50'
                }`}
              >
                {featured.status}
              </span>
              <span className="inline-flex items-center gap-1 rounded-md bg-background-50/15 px-2.5 py-1 text-xs text-background-50">
                <i className="ri-fire-fill text-primary-300" />
                热度 {formatHeat(featured.heat)}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
              <Link to={`/topic/${featured.slug}`} className="cursor-pointer hover:text-primary-300">
                {featured.title}
              </Link>
            </h3>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-background-200/90 line-clamp-2">
              {featured.summary}
            </p>
            <Link
              to={`/topic/${featured.slug}`}
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-foreground-950 transition-colors hover:bg-primary-400"
            >
              查看完整时间线
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </article>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-1">
          {gridTopics.slice(0, 2).map((topic) => (
            <article
              key={topic.slug}
              className="flex gap-4 rounded-lg border border-background-200/80 bg-background-50 p-4 transition-colors hover:border-primary-300"
            >
              <Link
                to={`/topic/${topic.slug}`}
                className="relative h-24 w-28 shrink-0 cursor-pointer overflow-hidden rounded-md md:h-28 md:w-36"
              >
                <img
                  src={topic.cover}
                  alt={`${topic.title} - 网报吃瓜专题`}
                  title={`${topic.title} - 网报吃瓜`}
                  className="h-full w-full object-cover object-top"
                />
              </Link>
              <div className="flex min-w-0 flex-1 flex-col">
                <span className="text-xs text-accent-700">{topic.category}</span>
                <h3 className="mt-1.5 font-heading text-sm font-bold leading-snug text-foreground-950 md:text-base">
                  <Link to={`/topic/${topic.slug}`} className="cursor-pointer hover:text-primary-700">
                    {topic.title}
                  </Link>
                </h3>
                <p className="mt-1.5 flex-1 text-xs leading-relaxed text-foreground-600 line-clamp-2">
                  {topic.summary}
                </p>
                <span className="mt-2 inline-flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-refresh-line" />
                  {topic.updateCount} 条更新 · {topic.followers} 关注
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {restTopics.slice(2, 5).map((topic) => (
          <TopicCard key={topic.slug} topic={topic} />
        ))}
      </div>
    </section>
  );
}

export default TopicShowcase;